export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
};

export const formatDate = (dateString) => {
  // date comes in as "2024-01-01T00:00:00.000Z", but we only want to display the date portion in a more user-friendly format like MM/DD/YYYY"
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, options);
};

export const formatDateTime = (dateString) => {
  const options = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
  const date = new Date(dateString);
  return date.toLocaleString(undefined, options);
};

export const formatTime = (dateTimeString) => {
  const date = new Date(dateTimeString);

  const localTimeWithName = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short", // 'short' (e.g., EST) or 'long' (e.g., Eastern Standard Time),
    hourCycle: "h12",
  }).format(date);

  return localTimeWithName;
};

/**
 * Determines whether `address1` is a street-only value, or already
 * contains the city/state/zip that's also stored in the record's
 * separate fields — so callers can avoid duplicating that info on display.
 *
 * @param {object} record
 * @param {string} record.address1
 * @param {string} [record.city]
 * @param {string} [record.state]
 * @param {string} [record.zip]
 * @returns {{
 *   isStreetOnly: boolean,
 *   includesCity: boolean,
 *   includesState: boolean,
 *   includesZip: boolean,
 *   streetOnlyValue: string
 * }}
 */
export const analyzeAddress1 = (record = {}) => {
  const address1 = (record.address1 || '').trim();
  const city = (record.city || '').trim();
  const state = (record.state || '').trim();
  const zip = (record.zip || '').trim();

  const lowerAddr = address1.toLowerCase();

  const includesCity = !!city && lowerAddr.includes(city.toLowerCase());
  const includesState = !!state && new RegExp(`\\b${state}\\b`, 'i').test(address1);
  const includesZip = !!zip && address1.includes(zip);

  const isStreetOnly = !includesCity && !includesState && !includesZip;

  let streetOnlyValue = address1;
  if (!isStreetOnly) {
    streetOnlyValue = address1
      .split(',')[0]
      .trim();
  }

  return {
    isStreetOnly,
    includesCity,
    includesState,
    includesZip,
    streetOnlyValue,
  };
}
